import { useQuery } from "@tanstack/react-query";
import { public_service_provider_api_requests, SERVICE_PROVIDER_API } from "..";

const PATH = "/service-provider/public/home-stats";
const QUERY_KEY = [SERVICE_PROVIDER_API + PATH];

export interface HomeStatsResponse {
  activeCities: number;
  activeServiceProviders: number;
  totalCategories: number;
}

const useGetHomeStats = () => {
  return useQuery<HomeStatsResponse>({
    queryKey: QUERY_KEY,
    queryFn: () => public_service_provider_api_requests.get(PATH),
    staleTime: 10 * 60 * 1000, // 10 minutes — stats don't change per-request
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export { useGetHomeStats, QUERY_KEY as HOME_STATS_QUERY_KEY };
